<template>
    <CompassEmptyState
        illustrationPath="/ressources/logged/img/illustrations/no-results.svg"
        :title="$t.__('email.listings.EmailListingTableEmpty.no_result')"
    >
        <CompassButton
            v-if="hasActiveFilters"
            :label="$t.__('common.actions.reset')"
            @click="handleResetFilters"
        />
    </CompassEmptyState>
</template>

<script>
export default {
    props: {
        hasActiveFilters: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleResetFilters() {
            this.$emit('resetFilters');
        },
    },
};
</script>
